import { type ConnectorResult, type ConnectorResultError } from '../../../models/AccountOpening'
import { type AccountOpeningDescriptor } from '../../../models/AccountOpeningDescriptor'
import { presentString } from './schemaValues'

export interface SubmissionOutcome {
  ok: boolean
  referenceId: string | null
  statusCode: string | null
  handoffUrl: string | null
  errors: ConnectorResultError[]
}

export const submissionOutcome = (result: ConnectorResult): SubmissionOutcome => ({
  ok: result.ok,
  referenceId: presentString(result.referenceId),
  statusCode: presentString(result.statusCode),
  handoffUrl: presentString(result.handoffUrl),
  errors: result.errors ?? [],
})

export const operationSucceeded = (outcome: SubmissionOutcome | null | undefined): boolean => !!outcome?.ok && outcome.errors.length === 0

export const statusLabelsOf = (descriptor: AccountOpeningDescriptor | undefined): Record<string, string> => descriptor?.labels.statusLabels ?? {}

export const statusLabel = (labels: Record<string, string>, statusCode: string | null | undefined): string =>
  statusCode ? (labels[statusCode] ?? statusCode) : ''

export const outcomeMetadata = (outcome: SubmissionOutcome): Record<string, unknown> => ({
  ok: outcome.ok,
  errors: outcome.errors,
  referenceId: outcome.referenceId,
  statusCode: outcome.statusCode,
  handoffUrl: outcome.handoffUrl,
})

export const storedOutcome = (metadata: Record<string, unknown> | undefined): SubmissionOutcome => {
  const stored = metadata as { ok?: boolean; errors?: ConnectorResultError[]; referenceId?: string; statusCode?: string; handoffUrl?: string } | undefined
  return {
    ok: stored?.ok ?? true,
    referenceId: presentString(stored?.referenceId),
    statusCode: presentString(stored?.statusCode),
    handoffUrl: presentString(stored?.handoffUrl),
    errors: stored?.errors ?? [],
  }
}

export const storedStatusCode = (metadata: Record<string, unknown> | undefined): string | null => storedOutcome(metadata).statusCode
